module.exports = __webpack_public_path__ + "img/ayoba_logo.a300011f.png";